import { c as _c } from "react/compiler-runtime";
import { Fragment } from 'react';
import { useTranslation } from '@/hooks/use-translation';
import { cn } from '@/lib/utils';
export interface Crumb {
  text: string;
  tone: 'step' | 'mid' | 'leaf';
}
const toneClassName: Record<Crumb['tone'], string> = {
  leaf: 'text-foreground',
  mid: '',
  step: 'text-ptl-brass'
};

/** The route, in monospaced capitals: `02 / ANALYZE / FRONT WEIGHT`. */
export const Breadcrumb = t0 => {
  const $ = _c(7);
  const {
    crumbs
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("Breadcrumb", {
      ns: "navigation"
    });
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== crumbs) {
    t2 = crumbs.map(_temp);
    $[2] = crumbs;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <nav aria-label={t1} className="flex flex-wrap items-center gap-2 font-mono text-xs tracking-[0.06em] text-muted-foreground uppercase">{t2}</nav>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(crumb, index) {
  return <Fragment key={`${crumb.text}-${String(index)}`}>{index > 0 ? <span aria-hidden="true" className="text-input">/</span> : null}<span className={cn(toneClassName[crumb.tone])}>{crumb.text}</span></Fragment>;
}